var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"90vh"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none","overflow":"hidden"},attrs:{"src":"https://www.learnlink.no/bruksvilkar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }